import { Box, Stack, Typography } from "@mui/material"
import { rise } from "../motion"

/**
 * Title, optional subtitle, and a slot for the page's actions.
 *
 * `subtitle` takes a node as well as a string. A string is wrapped in the muted
 * body style every page uses; anything else is rendered as it is, because a
 * header that needs a logo, a chip or two lines cannot be a paragraph — putting
 * one inside a <p> is invalid markup and the browser closes the paragraph early,
 * which moves the rest of it out from under the title.
 */
export default function PageHeader({ title, subtitle, actions, sx }) {
  return (
    <Stack
      direction={{ xs: "column", sm: "row" }}
      spacing={2}
      alignItems={{ xs: "flex-start", sm: "center" }}
      justifyContent="space-between"
      sx={{ mb: 3, ...rise(), ...sx }}
    >
      <Box sx={{ minWidth: 0 }}>
        <Typography variant="h1" noWrap={false}>
          {title}
        </Typography>
        {typeof subtitle === "string" ? (
          <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
            {subtitle}
          </Typography>
        ) : subtitle ? (
          <Box sx={{ mt: 0.75 }}>{subtitle}</Box>
        ) : null}
      </Box>
      {actions ? <Stack direction="row" spacing={1} flexWrap="wrap">{actions}</Stack> : null}
    </Stack>
  )
}
